import { BiLink } from "react-icons/bi";
import Button from "@components/button/Button";
import logo from "@assets/images/hih-initiative-en.svg";
import { useIconSize } from "@app/hooks";
import { FAO_INVESTMENT_FORUM_URL } from "../constants";

const HihForumHeader = () => {
  const iconSize = useIconSize(16);

  return (
    <div className="hih-forum-header">
      <div className="hih-forum-header-copy">
        <h1 className="hih-forum-title">Sustainable Investments</h1>
        <p className="hih-forum-intro">
          The EX-ACT tool supports the quantification of climate impacts of investment notes developed by countries taking part in the Hand in Hand initiative. You can click on countries below to consult GHG assessment.
        </p>
      </div>
      <div className="hih-forum-brand">
        <img src={logo} alt="Sustainable Investments" className="hih-forum-logo" />
        <Button
          className="hih-forum-cta"
          onClick={() => window.open(FAO_INVESTMENT_FORUM_URL, "_blank", "noopener,noreferrer")}
        >
          Visit FAO Investment Forum
          <BiLink size={iconSize} />
        </Button>
      </div>
    </div>
  );
};

export default HihForumHeader;
